// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"ActualSupplierOfAssets_modal-content_12lic"};